import ZoomServices from "../../../services/ZoomServices";

const ZOOM_STORAGE_KEY = "zoom_auth";
const MILLISECONDS_TO_SECONDS = 1000;

export function getZoomAuth() {
  const raw = localStorage.getItem(ZOOM_STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setZoomAuth(token) {
  const expires_at =
    Math.floor(Date.now() / MILLISECONDS_TO_SECONDS) + token.expires_in;

  const normalizedToken = {
    ...token,
    expires_at
  };

  localStorage.setItem(
    ZOOM_STORAGE_KEY,
    JSON.stringify(normalizedToken)
  );
}

export function clearZoomAuth() {
  localStorage.removeItem(ZOOM_STORAGE_KEY);
}

export function isZoomTokenExpired(token) {
  if (!token?.expires_at) return true;
  return Math.floor(Date.now() / 1000) >= token.expires_at;
}

export async function getValidZoomAccessToken() {
  const token = getZoomAuth();
  if (!token) return null;

  //  Still valid
  if (!isZoomTokenExpired(token)) {
    return token.access_token;
  }

  //  Refresh flow
  if (!token.refresh_token) {
    clearZoomAuth();
    return null;
  }

  try {
    const refreshed = await ZoomServices.refreshToken(
      token.refresh_token
    );

    setZoomAuth(refreshed);
    return refreshed.access_token;
  } catch {
    clearZoomAuth();
    return null;
  }
}
